import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { PontoCriticoAcaoService } from "../services/ponto-critico-acao.service";

@Injectable({
  providedIn: 'root'
})
export class AcaoStatusListResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdStatus();
  }
}

@Injectable({
  providedIn: 'root'
})
export class AcaoStatusListEntregaResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdEntregaStatus();
  }
}

@Injectable({
  providedIn: 'root'
})
export class AcaoStatusListIndicadorResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdIndicadorStatus();
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoAcaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoEntregaAcaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdEntrega(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoIndicadorAcaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdIndicador(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoAgregadorIndicadorAcaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdAgregadorIndicador(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoAcaoSimplificadoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdSimple(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoEntregaAcaoSimplificadoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdEntregaSimple(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoIndicadorAcaoSimplificadoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdIndicadorSimple(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoAgregadorIndicadorAcaoSimplificadoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdAgregadorIndicadorSimple(route.params.idAcao);
  }
}